export default __webpack_public_path__ + "static/media/INNOMOTICS-logo-lime-RGB.09e58387.svg";